import { Box } from "@mui/system";
import img from "../../Assets/babyfood.png";
import DownloadButton from "../Common/DownloadButton";
import { Treemap } from "@antv/g2plot";
import { useEffect } from "react";

const TreeMapChart = (props) => {
  const data = {
    children: [
      {
        name: "Baby foods other than \n processed cereal-based foods \n\n 276",
        value: 276,
      },
      {
        name: "Processed cereal-based foods \n for infants and young children\n\n 547",
        value: 574,
      },
      { name: "Infant\n formulae\n\n 139", value: 139 },
      { name: "Food for infants and\n young children\n\n 412", value: 412 },
      { name: "Follow-on\n formulae\n\n 172", value: 172 },
    ],
  };

  useEffect(() => {
    const treemapPlot = new Treemap(document.getElementById("treeMap"), {
      data,
      legend: false,
      // tooltip: {
      //   customContent: (title, items) => {
      //     // Custom tooltip content
      //     return `<div class="custom-tooltip">
      //               <div class="tooltip-title">Title</div>
      //               <div class="tooltip-items">
      //                 ${items.map((item) => `<div>${item.name}</div>`).join("")}
      //               </div>
      //             </div>`;
      //   },
      // },
      tooltip: {
        customContent: (title, items) => {
          // Custom tooltip content
          return `<div  
          style="white-space: nowrap; left: 397.5px; top: 185px; padding: 16px;">
            <div >
              <div >
                  <div>
                  ${items
                    .map((item) => {
                      const temp = item.name.split(" ");
                      temp.splice(-1);
                      return `<div class="tooltipWrapper" style="overflow-wrap: break-word;">
                  <span id="repCountrytooltip"><b>${temp.join(" ")}</b>
                  </span>
                  <br>
                  <span id="repCountrytooltip2" 
                  style="color: rgb(34, 41, 77); padding-bottom: 0px; font-size: 12px;">Number of samples: ${item.value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} </span>
              </div>`;
                    })
                    .join("")}
                  
              </div>
          </div>
          </div>
          </div>`;
        },
      },
      colorField: "#38b292",
      label: {
        type: "",
        formatter: (item) => {
          return item.name; // Display the name as label (adjust as needed)
        },
        style: {
          fill: "#22294d", // Change the label text color
          fontSize: 13, // Change the label font size
          fontWeight: 700,
          fontFamily: "Roboto Condensed-Bold, Roboto Condensed",
        },
      },
    });

    treemapPlot.render();

    return () => {
      treemapPlot.destroy();
    };
  }, []);
  return (
    <Box>
      <Box display="flex" justifyContent="space-between">
        <p
          style={{
            marginBottom: "1.1rem",
            fontFamily: "Roboto Condensed, sans-serif",
          }}
        >
          {props.title}
        </p>
        <DownloadButton fileName={props.title} imageAsset={img} />
      </Box>

      <div id="treeMap"></div>
    </Box>
  );
};

export default TreeMapChart;
